import { Eye, Gift } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

function OrderHistoryTable({ rows, onOpenOrderDetails, onOpenNotes }) {
  return (
    <div className="mt-3 overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow className="border-b border-white/10 bg-[#2F3133]">
            <TableHead className="text-cwhite text-sm">Date</TableHead>
            <TableHead className="text-cwhite text-sm">Order ID</TableHead>
            <TableHead className="text-cwhite text-sm">Order Type</TableHead>
            <TableHead className="text-cwhite text-sm">Order Price</TableHead>
            <TableHead className="text-cwhite text-sm">Discount</TableHead>
            <TableHead className="text-cwhite text-sm">Loyalty</TableHead>
            <TableHead className="text-cwhite text-sm">Earn points</TableHead>
            <TableHead className="text-cwhite text-sm">Notes</TableHead>
            <TableHead className="text-cwhite text-sm">Operator</TableHead>
            <TableHead className="text-cwhite text-sm">Status</TableHead>
            <TableHead className="text-right text-cwhite text-sm">Action</TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {rows?.length ? (
            rows.map((row) => (
              <TableRow key={row?.id} className="border-b border-white/10">
                <TableCell className="text-sm text-cwhite2">{row?.date}</TableCell>
                <TableCell className="text-sm text-cwhite2">{row?.orderId}</TableCell>
                <TableCell className="text-sm text-cwhite2">{row?.orderType}</TableCell>
                <TableCell className="text-sm text-cwhite2">{row?.orderPrice}</TableCell>
                <TableCell className="text-sm text-cwhite2">{row?.discount}</TableCell>
                <TableCell className="text-sm text-cwhite2">{row?.loyalty}</TableCell>
                <TableCell className="text-sm text-cwhite2">{row?.earnPoints}</TableCell>
                <TableCell className="text-sm text-cwhite2">
                  <button type="button" onClick={() => onOpenNotes(row?.notes)}>
                    <Eye className="text-cwhite2" size={18} />
                  </button>
                </TableCell>
                <TableCell className="text-sm text-cwhite2">{row?.operator}</TableCell>
                <TableCell className="text-sm text-cgreen">{row?.status}</TableCell>
                <TableCell>
                  <div className="flex justify-end gap-3 text-cwhite2">
                    <button type="button" onClick={() => onOpenOrderDetails(row)}>
                      <Eye size={18} />
                    </button>
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow className="border-b border-white/10">
              <TableCell colSpan={11} className="text-center text-cwhite2">
                No order history found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}

export default OrderHistoryTable;
